import gql from "graphql-tag";

/* -------------------------------------------------------------------------- */
/*                            moderator assignment                            */
/* -------------------------------------------------------------------------- */
export const ASSIGN_BATCH_TO_MOD = gql`
    mutation AssignPhotoBatchToModerator($photoBatchId: ID!, $moderatorId: ID) {
        assign: assignPhotoBatchToModerator(
            photoBatchId: $photoBatchId
            moderatorId: $moderatorId
        ) {
            errors
            ok
            photoBatch {
                id
                moderator {
                    displayName
                    id
                    isManager
                    isPhotoModerator
                    username
                }
            }
        }
    }
`;

/* -------------------------------------------------------------------------- */
/*                               moderation band                              */
/* -------------------------------------------------------------------------- */
export const SAVE_UPLOADS_FOR_LATER = gql`
    mutation SaveUploadsForLater($photoUploadIds: [ID!]!) {
        save: savePhotoUploadsForLater(photoUploadIds: $photoUploadIds) {
            errors
            ok
            individualResponses: photoUploads {
                errors
                ok
                photoUploadId
                photoUpload {
                    id
                    status
                }
            }
        }
    }
`;

export const REMOVE_UPLOADS_FROM_SAVED_FOR_LATER = gql`
    mutation ResumeModeratingSavedForLaterPhotoUploads(
        $photoUploadIds: [ID!]!
    ) {
        resume: resumeModeratingSavedForLaterPhotoUploads(
            photoUploadIds: $photoUploadIds
        ) {
            errors
            ok
            individualResponses: photoUploads {
                photoUploadId
                errors
                ok
                photoUpload {
                    id
                    status
                }
            }
        }
    }
`;

export const SET_GEM_STATUS_ON_UPLOADS = gql`
    mutation SetGemStatusOnUploads($photoUploadIds: [ID!]!, $value: Boolean!) {
        setGemStatus: setStarredStatusOnPhotoUploads(
            photoUploadIds: $photoUploadIds
            value: $value
        ) {
            ok
            photoUploads {
                ok
                errors
                photoUploadId
                photoUpload {
                    id
                    isGem: starred
                }
            }
        }
    }
`;

export const SET_MATURE_ON_UPLOADS = gql`
    mutation SetMatureOnPhotoUploads(
        $photoUploadIds: [ID!]!
        $value: Boolean!
    ) {
        setMatureOnPhotoUploads(
            photoUploadIds: $photoUploadIds
            value: $value
        ) {
            ok
            photoUploads {
                errors
                ok
                photoUploadId
                photoUpload {
                    mature
                }
            }
        }
    }
`;

/* -------------------------------------------------------------------------- */
/*                                upload flags                                */
/* -------------------------------------------------------------------------- */
export const SET_EXPLICIT_STATUS_ON_UPLOADS = gql`
    mutation SetExplicitStatusOnUploads(
        $photoUploadIds: [ID!]!
        $value: Boolean!
    ) {
        setExplicitStatusOnUploads: setExplicitContentOnPhotoUploads(
            photoUploadIds: $photoUploadIds
            value: $value
        ) {
            ok
            photoUploads {
                errors
                ok
                photoUploadId
                photoUpload {
                    autoNudity
                    autoViolence
                }
            }
        }
    }
`;

export const SET_NEEDS_RELEASE_STATUS_ON_UPLOADS = gql`
    mutation SetNeedsReleaseStatusOnUploads(
        $photoUploadIds: [ID!]!
        $value: Boolean!
    ) {
        setNeedsReleaseStatusOnUploads: setHasRecognizablePeopleOrPropertyOnPhotoUploads(
            photoUploadIds: $photoUploadIds
            value: $value
        ) {
            ok
            photoUploads {
                errors
                ok
                photoUploadId
                photoUpload {
                    hasRecognizablePeopleOrProperty
                }
            }
        }
    }
`;

export const SET_EDITORIAL_USE_ONLY_ON_UPLOADS = gql`
    mutation SetEditorialUseOnlyOnPhotoUploads(
        $photoUploadIds: [ID!]!
        $value: Boolean!
    ) {
        setEditorialUseOnlyOnPhotoUploads(
            photoUploadIds: $photoUploadIds
            value: $value
        ) {
            ok
            photoUploads {
                errors
                ok
                photoUploadId
                photoUpload {
                    editorialUseOnly
                }
            }
        }
    }
`;

export const SET_HAS_WARNING_TEXT_ON_UPLOADS = gql`
    mutation SetHasFlaggedTextOnPhotoUploads(
        $photoUploadIds: [ID!]!
        $value: Boolean!
    ) {
        setHasFlaggedTextOnPhotoUploads(
            photoUploadIds: $photoUploadIds
            value: $value
        ) {
            ok
            photoUploads {
                errors
                ok
                photoUploadId
                photoUpload {
                    autoWarningText
                }
            }
        }
    }
`;

/* -------------------------------------------------------------------------- */
/*                           upload approval/denial                           */
/* -------------------------------------------------------------------------- */
export const DENY_PHOTO_UPLOADS = gql`
    mutation DenyPhotoUploads($photoUploadIds: [ID!]!) {
        payload: denyPhotoUploads(photoUploadIds: $photoUploadIds) {
            ok
            errors
            photoUploads {
                id
                status
            }
        }
    }
`;

export const VISUALLY_PUBLISH_PHOTO_UPLOADS = gql`
    mutation VisuallyPublishPhotoUploads($photoUploadIds: [ID!]!) {
        payload: approvePhotoUploads(
            photoUploadIds: $photoUploadIds
            isMetadataApproved: false
        ) {
            ok
            errors
            photoUploads {
                id
                status
            }
        }
    }
`;

export const FULLY_PUBLISH_PHOTO_UPLOADS = gql`
    mutation FullyPublishPhotoUploads($photoUploadIds: [ID!]!) {
        payload: approvePhotoUploads(
            photoUploadIds: $photoUploadIds
            isMetadataApproved: true
        ) {
            ok
            errors
            photoUploads {
                id
                status
            }
        }
    }
`;
